<template>
  <div>
    <editor
      :id="editorId"
      api-key="f9tg25pq47z4zweve160g3wt475r0oycir62ddltkzsd8v6w"
      :init="initOptions"
      v-model="data"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
export default {
  components: {
    editor: Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: this.value || '',
      editorId: `tinymce-editor-${this._uid}`,
      initOptions: {
        height: 350,
        menubar: 'file edit insert view format table tools help',
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount toc'
        ],
        toolbar:
          'undo redo | formatselect | bold italic underline code backcolor | ' +
          'alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist outdent indent | removeformat | help | toc',
        branding: false
      }
    }
  },
  watch: {
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      if (value !== this.data) {
        this.data = value || ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
